import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableOrientation = 'horizontal' | 'vertical';

const options = [
    { value: 'horizontal', label: 'Horizontal' },
    { value: 'vertical', label: 'Vertical' },
] as Option<CableOrientation>[];

const validator = z.enum(['horizontal', 'vertical']);

export const CableOrientation = {
    validator,
    options,
};
